import DadosCobranca from './DadosCobranca'
import Loading from './Loading'
import Menu from './Menu'
import NavBar from './NavBar'
import Pagamento from './Pagamento'
import Status from './Status'
import TheFooter from './TheFooter'

export default {
  DadosCobranca,
  Loading,
  Menu,
  NavBar,
  Pagamento,
  Status,
  TheFooter,
}
